import { useRouter, useSearch } from "@tanstack/react-router"

import { GoBack } from "@/components/shared"
import { Button } from "@/components/ui"
import { SubmissionDetailsSheet } from "@/features/jobs/manage/components/submission-details-sheet"
import { ETypeNotification } from "@/modules/helpers/enum"
import { useShowSubmission } from "@/modules/helpers/hooks/shared"
import { sendOpenLink } from "@/modules/helpers/utils"

interface NotificationDetailProps {
  id: string
}

const BUTTON_TEXT = {
  [ETypeNotification.INVITE_RECEIVE_SAMPLE]: "Yêu cầu mẫu ngay",
  [ETypeNotification.CUSTOMIZE_NOTIFICATION_JOIN]: "Tham gia ngay",
  default: "Xem ngay"
}

export const NotificationDetail = ({ id }: NotificationDetailProps) => {
  const { deeplink, type, buttonText } = useSearch({ strict: false }) as {
    deeplink?: string
    type?: ETypeNotification
    buttonText?: string
  }

  const router = useRouter()
  const { setId, id: showId } = useShowSubmission()

  const handleGoBack = () => {
    if (window.history.length > 1) {
      window.history.back()
    } else {
      router.navigate({ to: "/" })
    }
  }

  const handleViewNow = () => {
    const isDeliveryOrDelivered =
      type === ETypeNotification.DELIVERED || (type as string) === "DELIVERY"

    if (isDeliveryOrDelivered && deeplink && !deeplink.includes("http")) {
      setId(deeplink)
      return
    }

    if (deeplink?.includes("http")) {
      sendOpenLink(deeplink || "")
    } else {
      if (deeplink) router.navigate({ to: deeplink })
    }
  }

  return (
    <div className="flex flex-col h-full">
      {!showId && <GoBack title="Chi tiết thông báo" onClick={handleGoBack} className="bg-white" />}
      <div className="flex-1 overflow-scroll">
        <iframe
          src={`${import.meta.env.VITE_WEB_BRAND_URL}/notifications/${id}?webview=1`}
          className="w-full h-full"
        />
      </div>
      {deeplink && (
        <div className="p-4 bg-white">
          <Button
            onClick={handleViewNow}
            className="w-full !h-12 rounded-xl bg-primary-800 hover:opacity-90"
          >
            {buttonText || BUTTON_TEXT[type as keyof typeof BUTTON_TEXT] || BUTTON_TEXT.default}
          </Button>
        </div>
      )}
      <SubmissionDetailsSheet />
    </div>
  )
}
